/* eslint-disable react/prop-types */
import { Box, Tooltip } from '@mui/material';
import perfectRxTheme from 'common/theme/perfectRxTheme';

export const BUSINESS_ADDRESS_TOOLTIP = 'Business address';

// POM-6516: a simple "B" for a non-batched order that ships to a business address. Batched
// orders keep the "B" on BatchShippingIcon instead. Soft round badge (client-chosen option E):
// a 22 px circle with a pale yellow fill, dark amber "B" and portal-yellow border.
const BusinessAddressIndicator = ({ color = perfectRxTheme.palette.warning.warningColour }) => (
  <Tooltip title={BUSINESS_ADDRESS_TOOLTIP} arrow placement='top'>
    <Box
      component='span'
      role='img'
      aria-label={BUSINESS_ADDRESS_TOOLTIP}
      data-testid='BusinessAddressIndicator'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        width: 22,
        height: 22,
        borderRadius: '50%',
        border: `1px solid ${color}`,
        backgroundColor: '#FFF4CC',
        color: '#7A5200',
        fontSize: '12px',
        fontWeight: 800,
        lineHeight: 1,
        userSelect: 'none',
      }}
    >
      B
    </Box>
  </Tooltip>
);

export default BusinessAddressIndicator;
